import { FormProvider } from "react-hook-form";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../../../../components/ui/dialog";
import { BasicInput } from "../../../../../../components/BasicInput";
import { Button } from "../../../../../../components/ui/button";
import { cpfMask } from "../../../../../../../app/utils/cpfFormater";
import useNewSimulationModal from "./useNewSimulationModal";
import RegistrationCard from "../components/registrationCard";
import { Spinner } from "@/view/components/ui/spinner";

interface NewSimulationModalProps {
  onBack: () => void;
}

export default function NewSimulationModal({
  onBack,
}: NewSimulationModalProps) {
  const {
    handleNext,
    form,
    handleSubmit,
    isPending,
    list,
    selectedCard,
    setSelectedCard,
  } = useNewSimulationModal();
  const {
    formState: { errors },
  } = form;

  return (
    <DialogContent className="max-h-[90vh] max-w-[90%] overflow-y-auto md:max-w-[400px]">
      <DialogHeader className="border-b pb-8">
        <DialogTitle className="text-xl font-semibold text-black01">
          Vamos simular seu crédito
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Preencha os dados abaixo para gerar as matrículas disponíveis para
          simulação
        </DialogDescription>
      </DialogHeader>

      <form onSubmit={handleSubmit}>
        <FormProvider {...form}>
          <BasicInput
            name="cpf"
            maxLength={14}
            label="CPF"
            error={errors.cpf?.message}
            onInput={cpfMask}
          />
          {isPending ? (
            <div className="mt-8 flex justify-center">
              <Spinner size="small" />
            </div>
          ) : (
            <>
              {list && list.length > 0 ? (
                <div className="scrollbar-thin scrollbar-thumb-gray01 scrollbar-track-transparent mt-8 flex max-h-[350px] flex-col gap-4 overflow-y-auto">
                  {list?.map((item) => (
                    <RegistrationCard
                      key={item.RegistrationNumber}
                      cnpj={item.EmployerDocumentNumber.toString()}
                      onClick={() => setSelectedCard(item)}
                      selected={
                        selectedCard?.RegistrationNumber ===
                        item.RegistrationNumber
                      }
                      registrationNumber={item.RegistrationNumber}
                    />
                  ))}
                </div>
              ) : (
                !errors.cpf &&
                list &&
                list.length === 0 && (
                  <div className="mt-8 flex justify-center">
                    <p className="text-sm text-gray-800">
                      Nenhuma matrícula encontrada
                    </p>
                  </div>
                )
              )}
            </>
          )}
          <div className="mt-8 flex items-center justify-center gap-2">
            <Button
              variant="outline"
              onClick={onBack}
              className="w-[160px] rounded-full text-primary"
            >
              Voltar
            </Button>
            <Button
              type="button"
              onClick={handleNext}
              disabled={isPending || !selectedCard}
              className="w-[160px] rounded-full font-semibold text-white "
            >
              Prosseguir
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
